/**
 * @file   src\components\Common\InputGroup.js
 * @brief  This file is responsible for input group for location search component
 * @date   April, 2023
 * @author ZCO Engineer
 * @copyright (c) 2023, ZCO
 */
import { InputGroup, FormControl, Button } from "react-bootstrap";
import React from "react";

const InputGroupControl = (props) => {
  const {
    inputGroupClass,
    ariaLabel,
    ariaDescribedBy,
    placeholder,
    errorMessage,
    iconClass,
    isIconEnable,
    iconId,
    btnVariant,
    value,
    onChange,
    inputRef,
    disabled,
    onClick,
    onBlur,
    onFocus,
  } = props;

  return (
    <>
      <InputGroup className={inputGroupClass}>
        <FormControl
          aria-label={ariaLabel}
          aria-describedby={ariaDescribedBy}
          placeholder={placeholder}
          value={value}
          onChange={onChange}
          ref={inputRef}
          disabled={disabled}
          onClick={onClick}
          onBlur={onBlur}
          onFocus={onFocus}
          style={{
            cursor: disabled ? 'not-allowed' : 'pointer',
            opacity: disabled ? 0.5 : 1,
          }}
        />

        {isIconEnable ? (
          <Button
            variant={btnVariant}
            className={iconClass}
            id={iconId}
          ></Button>
        ) : (
          ""
        )}
      </InputGroup>
      {errorMessage && (
        <div className="error-msg">
          {errorMessage && errorMessage !== "" && (
            <span className="error-msg">{errorMessage}</span>
          )}
        </div>
      )}
    </>
  );
};

export default InputGroupControl;
